import { trackEvent } from '../lib/tracking';

interface Solucao {
  id: string;
  titulo: string;
  descricao: string;
  aplicacoes: string[];
  vantagens: string[];
  image: string;
}

const solucoes: Solucao[] = [
  {
    id: 'mdf',
    titulo: 'Divisória 100% MDF',
    descricao:
      'Painéis em MDF que oferecem privacidade visual total, com acabamento uniforme e integração natural ao mobiliário do ambiente.',
    aplicacoes: ['Salas privativas', 'Diretoria', 'Corredores'],
    vantagens: ['Privacidade total', 'Acabamento uniforme'],
    image:
      '/media/ia/0205.webp',
  },
  {
    id: 'mista',
    titulo: 'Divisória mista MDF + vidro',
    descricao:
      'Combina painel cego na base e vidro na parte superior, equilibrando privacidade e luminosidade em um único sistema.',
    aplicacoes: ['Salas de reunião', 'Escritórios', 'Recepção'],
    vantagens: ['Equilíbrio privacidade e luz', 'Design versátil'],
    image:
      '/media/ia/0206.webp',
  },
  {
    id: 'vidro-simples',
    titulo: 'Vidro simples',
    descricao:
      'Divisória de vidro para escritório com perfil discreto, maximizando a passagem de luz e a sensação de amplitude.',
    aplicacoes: ['Open office', 'Salas de reunião', 'Recepção'],
    vantagens: ['Máxima luminosidade', 'Perfil slim'],
    image:
      '/media/ia/0207.webp',
  },
  {
    id: 'vidro-duplo',
    titulo: 'Piso-Teto Vidro Duplo',
    descricao:
      'Divisórias de vidro são a solução perfeita para quem busca ambientes claros e funcionais. Além de separar os espaços, elas permitem a entrada máxima de luz natural, reduzindo a necessidade de iluminação artificial. As divisórias Piso-Teto de vidro Duplo estão disponíveis em vidros laminados ou temperados, ambos garantem durabilidade e segurança, além de proporcionar melhor solução acústica. As estruturas são compostas de perfil de alumínio anodizado fosco nas cores prata ou preto e permitem a instalação de persianas internas com acionamento através de botão. Além do mais, possui flexibilidade de adaptação de layouts, seus painéis podem ser removidos e reconfigurados de acordo com as necessidades da empresa.',
    aplicacoes: ['Diretoria', 'Salas de reunião', 'RH', 'Consultórios'],
    vantagens: ['Melhor solução acústica', 'Vidros laminados ou temperados', 'Persianas internas com acionamento por botão', 'Flexibilidade de adaptação de layouts', 'Perfil de alumínio anodizado fosco'],
    image:
      'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/divisoria-piso-teto-vidro-duplo1.webp',
  },
  {
    id: 'junta-seca',
    titulo: 'Junta seca slim',
    descricao:
      'Divisória modular de linhas reduzidas, pensada para projetos que valorizam a estética minimalista e contemporânea.',
    aplicacoes: ['Escritórios', 'Salas privativas', 'Áreas administrativas'],
    vantagens: ['Linhas slim', 'Estética contemporânea'],
    image:
      '/media/ia/0208.webp',
  },
  {
    id: 'acustica',
    titulo: 'Soluções acústicas',
    descricao:
      'Divisória acústica com tratamento interno, indicada para ambientes que exigem privacidade sonora e conforto de fala.',
    aplicacoes: ['Salas de reunião', 'Consultórios', 'Financeiro'],
    vantagens: ['Conforto sonoro', 'Privacidade de fala'],
    image:
      '/media/ia/0209.webp',
  },
  {
    id: 'biombo',
    titulo: 'Biombo AL-8',
    descricao:
      'Sistema de divisórias para escritório independente, ideal para setorizar ambientes com flexibilidade e sem fixação estrutural.',
    aplicacoes: ['Open office', 'Coworking', 'Áreas de apoio'],
    vantagens: ['Flexibilidade total', 'Instalação descomplicada'],
    image:
      '/media/ia/0210.webp',
  },
  {
    id: 'portas',
    titulo: 'Portas estruturadas',
    descricao:
      'Portas integradas ao sistema de divisórias, com fechamento que acompanha o perfil e acabamento do conjunto.',
    aplicacoes: ['Salas de reunião', 'Diretoria', 'Salas privativas'],
    vantagens: ['Integração ao sistema', 'Acabamento contínuo'],
    image:
      '/media/ia/0211.webp',
  },
  {
    id: 'sanitarias',
    titulo: 'Divisórias sanitárias',
    descricao:
      'Divisórias para banheiros corporativos em material compacto, com acabamento resistente e higienização facilitada.',
    aplicacoes: ['Banheiros corporativos', 'Áreas comuns'],
    vantagens: ['Resistência', 'Higienização facilitada'],
    image:
      '/media/ia/0212.webp',
  },
  {
    id: 'persiana',
    titulo: 'Sistemas com persiana integrada',
    descricao:
      'Divisória com persiana instalada entre os vidros, unindo estética e controle de privacidade em um único sistema.',
    aplicacoes: ['Salas de reunião', 'Diretoria', 'Consultórios'],
    vantagens: ['Controle de privacidade', 'Acabamento limpo'],
    image:
      'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/especificacoes/persianas.jpg',
  },
];

export default function SolucoesSection() {
  return (
    <section className="bg-background-50">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Tipos de soluções
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[38px] font-semibold tracking-tight leading-tight">
            Um sistema para cada necessidade do ambiente.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {solucoes.map((s) => (
            <article
              key={s.id}
              className="group bg-white rounded-2xl border border-background-200/60 overflow-hidden flex flex-col"
            >
              <div className="img-zoom overflow-hidden bg-background-100 aspect-[16/10]">
                <img
                  src={s.image}
                  alt={s.titulo}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="p-7 md:p-8 flex flex-col flex-1">
                <h3 className="text-foreground-950 font-semibold text-[18px] md:text-[20px] mb-2.5">
                  {s.titulo}
                </h3>
                <p className="text-foreground-500 text-[14px] leading-relaxed font-light mb-6">
                  {s.descricao}
                </p>

                <div className="mt-auto space-y-4">
                  <div>
                    <p className="text-[11px] font-semibold uppercase tracking-wider text-foreground-400 mb-2">
                      Aplicações recomendadas
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {s.aplicacoes.map((a) => (
                        <span
                          key={a}
                          className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-[12px]"
                        >
                          {a}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div>
                    <p className="text-[11px] font-semibold uppercase tracking-wider text-foreground-400 mb-2">
                      Vantagens
                    </p>
                    <ul className="space-y-1.5">
                      {s.vantagens.map((v) => (
                        <li
                          key={v}
                          className="flex items-center gap-2 text-foreground-600 text-[13px]"
                        >
                          <i className="ri-check-line text-primary-500 text-sm"></i>
                          {v}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <a
                    href="#analise"
                    onClick={() => trackEvent('form_start', { source: `solucao_${s.id}` })}
                    className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-[14px] font-semibold transition-colors whitespace-nowrap cursor-pointer pt-1"
                  >
                    Analisar para meu projeto
                    <i className="ri-arrow-right-line text-base"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}